/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Sort_Price_DescInputs */

const en_search_sort_price_desc = /** @type {(inputs: Search_Sort_Price_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price ↓`)
};

const es_search_sort_price_desc = /** @type {(inputs: Search_Sort_Price_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio ↓`)
};

const fr_search_sort_price_desc = /** @type {(inputs: Search_Sort_Price_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix décroissant`)
};

const de_search_sort_price_desc = /** @type {(inputs: Search_Sort_Price_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preis ↓`)
};

const ja_search_sort_price_desc = /** @type {(inputs: Search_Sort_Price_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`価格の高い順`)
};

const zh_search_sort_price_desc = /** @type {(inputs: Search_Sort_Price_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`价格 ↓`)
};

const ar_search_sort_price_desc = /** @type {(inputs: Search_Sort_Price_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السعر ↓`)
};

const id_search_sort_price_desc = /** @type {(inputs: Search_Sort_Price_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga ↓`)
};

const it_search_sort_price_desc = /** @type {(inputs: Search_Sort_Price_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezzo ↓`)
};

const ru_search_sort_price_desc = /** @type {(inputs: Search_Sort_Price_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сначала дорогие`)
};

const pt_search_sort_price_desc = /** @type {(inputs: Search_Sort_Price_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maior Preço`)
};

const ko_search_sort_price_desc = /** @type {(inputs: Search_Sort_Price_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`높은 가격순`)
};

/**
* | output |
* | --- |
* | "Price ↓" |
*
* @param {Search_Sort_Price_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const search_sort_price_desc = /** @type {((inputs?: Search_Sort_Price_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Sort_Price_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_search_sort_price_desc(inputs)
	if (locale === "es") return es_search_sort_price_desc(inputs)
	if (locale === "fr") return fr_search_sort_price_desc(inputs)
	if (locale === "de") return de_search_sort_price_desc(inputs)
	if (locale === "ja") return ja_search_sort_price_desc(inputs)
	if (locale === "zh") return zh_search_sort_price_desc(inputs)
	if (locale === "ar") return ar_search_sort_price_desc(inputs)
	if (locale === "id") return id_search_sort_price_desc(inputs)
	if (locale === "it") return it_search_sort_price_desc(inputs)
	if (locale === "ru") return ru_search_sort_price_desc(inputs)
	if (locale === "pt") return pt_search_sort_price_desc(inputs)
	return ko_search_sort_price_desc(inputs)
});